export const loggedInUserSelector = (store) => store.accountData.loggedInUser;
export const uploadCompanyLogoSelector = (store) => store.accountData.uploadCompanyLogoState;
export const isNewUserSelector = (store) => store.accountData.isNewUser;
export const gdprConsentSelector = (store) => store.accountData.gdprConsent;
export const isConfirmedGuestSelector = (store) => store.accountData.isConfirmedGuest;
